// import React from 'react';
// import './Footer.css';

// const Footer = () => {
//   return (
//     <footer className="app-footer">
//       <div className="footer-container">
//         <div className="footer-content">
//           <h3 className="footer-title">
//            Amenity<span className="footer-title-accent">Scores</span>
//           </h3>
//           <p className="footer-description">
//             Providing comprehensive, data-driven amenity analysis for any London property.
//           </p>
          
//           <div className="footer-links">
//             <a href="#" className="footer-link">Privacy Policy</a>
//             <a href="#" className="footer-link">Terms of Service</a>
//             <a href="#" className="footer-link">Contact Us</a>
//           </div>
          
//           <p className="footer-copyright">
//             © {new Date().getFullYear()} Property Amenities Rating Ltd. All rights reserved.
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


// src/components/Footer.js
import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {

    const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };



  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-content">
          <h3 className="footer-title">
           Amenity<span className="footer-title-accent">Scores</span>
          </h3>
          <p className="footer-description">
            Providing comprehensive, data-driven amenity analysis for any London property.
          </p>
          
          <div className="footer-links">
            <Link to="/privacy-policy" className="footer-link" onClick={scrollToTop}>Privacy Policy</Link>
            <Link to="/terms-of-service" className="footer-link" onClick={scrollToTop}>Terms of Service</Link>
            <Link to="/contact" className="footer-link" onClick={scrollToTop}>Contact Us</Link>
          </div>
          
          <p className="footer-copyright">
            © {new Date().getFullYear()} Property Amenities Rating Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;